import { Culture } from '../../types';

export const hopi: Culture = {
  name: 'Hopi',
  languageFamily: 'Uto-Aztecan',
  terms: [
    {
      word: 'Kiisonvi',
      phonetic: 'kee-son-vee',
      description: 'Hopi word meaning "plaza" or "village center."'
    },
    {
      word: 'Paaqavi',
      phonetic: 'pah-kah-vee',
      description: 'Hopi word meaning "reed."'
    },
    {
      word: 'Qöya',
      phonetic: 'koh-yah',
      description: 'Hopi word meaning "mountain."'
    },
    {
      word: 'Tutuveni',
      phonetic: 'too-too-veh-nee',
      description: 'Hopi word meaning "newspaper."'
    },
    {
      word: 'Tuuvi',
      phonetic: 'too-vee',
      description: 'Hopi word meaning "child."'
    }
  ]
};